<template>
  <v-container class="article">
      <v-row>
        <v-img
            class="white--text align-end"
            height="60vh"
            :src="getImage()"
        >
            <v-overlay
                absolute
                opacity="0.3"
            >
                <h2 class="title">
                    {{language =='Ελληνικά'? article.title : article.titleEn}}
                </h2>
            </v-overlay>
        </v-img>
      </v-row>

      <v-row class="date">{{getDate()}}</v-row>
      
      <v-row class="text mt-5">
          <span v-html="language =='Ελληνικά'? article.body : article.bodyEn"></span>
      </v-row>

  </v-container>
</template>


<script>
 import restApi from "@/rest-api";

  export default {
    props: {
        language: String
    },
    data() {
        return {
            article:{},
            id: 0
        }
    },
    created() {
      this.fetchArticle(this.$route.query.articleId);
    },
    methods: {
      fetchArticle(id) {
        var search = `/article/${id}`;
        restApi
        .get(search)
        .then(response => {
              this.article = response.article
        })
        .catch((error) => {
            console.log(error);
        });
      },
      getImage() {
        if(this.article.image) {
          return `https://dev.aggelopoulos-sarantis.com/uploads/images/${this.article.image.imageName}`
        } else {
          return require("@/assets/02-as-ktirio.jpg")
        }
      },
      getDate() {
        var date = new Date(this.article.createdAt)
        return date.getDate()+
          "/"+(date.getMonth()+1)+
          "/"+date.getFullYear()
      },
    }
  }
</script>

<style lang="scss" scoped>
    @media only screen and (min-width: 600px){
        .article{
            margin-top: 7%;
            width: 70%;
            height: auto;
            margin-bottom: 7%;
        }
    }

    @media only screen and (max-width: 600px){
        .article{
            margin-top: 20%;
            width: 90%;
            height: auto;
            margin-bottom: 20%;
        }
    }

    .title{
        text-align:center;
        font-weight:normal;
        margin-top: 3%;
        margin-bottom: 2%;
        font-size: 3vh!important;
    }
    .text{
        font-size: 2vh!important;
        padding:0% 10% 0% 10%; 
    }
</style>